import { render, staticRenderFns } from "./search_form.vue?vue&type=template&id=065567d4&"
import script from "./search_form.vue?vue&type=script&lang=js&"
export * from "./search_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports